import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-array/src/zip.js
// module id = DYHk
// module chunks = 0